<div *ngIf="currencies.length > 1" class="currency-container -eva-3-hide-small">
  <label for="currency-select" class="-eva-3-mr-sm">{{'currency-filter.label' | translate}}:</label>
  <div class="eva-3-select -md -no-resize select-wrapper">
    <div class="select-container">
      <select id="currency-select" class="select-tag" [ngModel]="selectedCurrency.value" (change)="changeCurrency($event)">
        <option class="select-option" *ngFor="let currency of currencies" [value]="currency.value">{{ currency.label }}</option>
      </select>
    </div>
  </div>
</div>

 <!--Selector de moneda para mobile-->
<div *ngIf="currencies.length > 1" class="filter-menu-fixed -eva-3-hide-medium -eva-3-hide-large">
  <div class="eva-3-order -one-item -eva-3-shadow-static">
    <ul class="order-container">
      <li class="order-item" (click)="currencyModal.show()">
        <a class="order-link">
          <i class="order-item-icon eva-3-icon-budget"></i>
          <span class="order-text">{{'currency-filter.label' | translate}}</span>
        </a>
      </li>
    </ul>
  </div>
</div>

<currency-modal [currencies]="currencies" (selectedCurrencyChanged)="setSelectedCurrency($event)"></currency-modal>